module.exports = __webpack_public_path__ + "img/symbol_2.de14146b.png";